import type { FaireProductEntity } from "../../entity_types/product";

export const p_6yd8fmtz67: FaireProductEntity = {
  token: "p_6yd8fmtz67",
  type: "product",
  name: "MAHJONG COIN PURSE SCP 732",
  brandToken: "b_2vcuhla4nw",
  brandName: "Tiana Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/f77f3c2cc3aecf88d69e7cd4a104d95863d1cf5901cc429124d67821bddd48dd.jpeg",
  galleryImageUrls: [],
  priceDollars: 23,
  description:
    "Elevate your style with the SCP coin purse from Tiana Designs. This purse is not just a fashion accessory, but a testament to exquisite craftsmanship. The coin purse is fully beaded, adding a touch of elegance and sophistication. It's the perfect blend of functionality and style, providing a secure storage solution for your coins. Every Tiana Designs purse is handcrafted by master craftsmen, using techniques perfected over time and choice beads sourced with utmost care. This coin purse not only keeps its elegant form for a long time but also ages gracefully.",
  tags: [],
  msrpDollars: 48.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:43.276Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
